import classnames from 'classnames';

import Icon from '~/components/icon';
import Link from '~/components/link';
import { type DrawerMenuItem } from '~/interfaces/HeaderFooterNavV2';

import styles from './single-link.module.css';

interface SingleLinkProps {
  callback?: (text: string) => void;
  hideIcons?: boolean;
  label?: string;
  page: DrawerMenuItem;
  pageDepth: number;
}

const SingleLink = ({
  callback,
  hideIcons = false,
  label,
  page,
  pageDepth = 0
}: SingleLinkProps) => {
  const { icon, link = '', name } = page;

  if (!name) {
    return null;
  }

  const renderIcon = (): JSX.Element | null => {
    if (!icon || hideIcons) return null;

    const [iconName, dimension = '16'] = icon.split(',');

    return (
      <div className={styles.iconContainer}>
				<Icon
          className={styles.linkIcon}
          height={parseInt(dimension, 10)}
          icon={iconName}
          width={parseInt(dimension, 10)} />

			</div>);

  };

  return (
    <div>
			<Link
        className={classnames(styles.link, styles[`link${pageDepth}`])}
        data-testid="page-link"
        key={name}
        preCallback={() => callback?.(label ? `${label} - ${name}` : name)}
        to={link}>

				{renderIcon()}
				<div className={styles.linkText}>{name}</div>
			</Link>
		</div>);

};

export default SingleLink;